import React from 'react';

export const Loading = (): JSX.Element => <p>Loading...</p>;
